module.exports = __webpack_public_path__ + "img/map-option-jigeng.b72c3e4e.png";